import React, { useState, useEffect } from "react";
import { db, } from "../../services/firebaseConfig";
import {
    collection,
    query,
    where,
    getDocs,
    orderBy,
} from "firebase/firestore";
import "../../styles/StockReport.css";

const StockReport = () => {
    const [filteredData, setFilteredData] = useState([]);
    const [user, setUser] = useState(null);

    useEffect(() => {
        const storedUser = JSON.parse(localStorage.getItem("user"));
        setUser(storedUser);
    }, []);

    useEffect(() => {
        if (!user) return;

        const fetchStockData = async () => {
            try {
                const stockRef = collection(db, "inventori", "selangor", "stockLogs");
                const q = user.role === "pengarah"
                    ? query(stockRef, orderBy("timestamp", "desc"))
                    : query(stockRef, where("district", "==", user.district), orderBy("timestamp", "desc"));


                const snapshot = await getDocs(q);
                const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                setFilteredData(data);
            } catch (error) {
                console.error("❌ Gagal memuatkan data stok:", error);
            }
        };

        fetchStockData();
    }, [user]);

    return (
        <div className="stock-report-container">
            <h2>Laporan Stok</h2>
            <table className="stock-report-table">
                <thead>
                    <tr>
                        <th>Nama Barang</th>
                        <th>Kategori</th>
                        <th>Kuantiti (+/-)</th>
                        <th>Status</th>
                        <th>Kawasan</th>
                        <th>Tarikh</th>
                    </tr>
                </thead>
                <tbody>
                    {filteredData.length === 0 ? (
                        <tr><td colSpan="6">Tiada rekod stok ditemui.</td></tr>
                    ) : (
                        filteredData.map((item, index) => (
                            <tr key={index}>
                                <td>{item.itemName}</td>
                                <td>{item.category}</td>
                                <td style={{ color: item.action.includes("masuk") ? "green" : "red" }}>
                                    {item.action.includes("masuk") ? "+" : "-"}{item.quantity} unit
                                </td>
                                <td>{item.action}</td>
                                <td>{item.district || "-"}</td>
                                <td>{item.timestamp?.toDate().toLocaleString("ms-MY")}</td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default StockReport;
